import styled from 'styled-components';
import rmq from 'styled-rmq';

export default styled.h1`
	/* font-size: 8rem; */
	font-size: 7.3rem;
	line-height: 1.24;
	font-weight: 900;
	margin: ${props => props.theme.vr * 0.89}rem 0;
	font-family: ${props => props.theme.fh1};
	color: ${props => props.theme.w};

	${rmq('700')} {
		font-size: 7rem;
	}
	${rmq('650')} {
		font-size: 5rem;
	}
	${rmq('ml')} {
		font-size: 3rem;
	}
	${rmq('ms')} {
		font-size: 2.5rem;
	}
`;
